import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('quote', ['getInputs']),
  },

  methods: {
    isTimeslotSelected(timeslot) {
      return this.getInputs.timeslot?.start_at === timeslot.start_at;
    },
  },
};
